import { Dispatch, MutableRefObject } from 'react';
import MobileService from '../ServiceStyle/MobileService';

const MobileStyle = ({ services, organization, scrollElementRef }: { scrollElementRef: Dispatch<HTMLElement>; organization: any; services: any }) => {
  if (!services) return null;

  if (!(services instanceof Array)) return null;

  return (
    <div className="mobile-list-style">
      {services.map((service) => (
        <MobileService scrollElementRef={scrollElementRef} key={service.service.hash} service={service.service} organization={organization} />
      ))}
    </div>
  );
};

export default MobileStyle;
